// Coordinates load as strings and come back from LatLngPicker as numbers, so
// unsaved-change checks compare them through this.
export const toCoord = (v) => (v === '' || v == null ? null : Number(v));

// CP-8061: a stop's warning is flagged on its map pin and next to its name. Both read this, so they cannot
// disagree; a warning of only spaces is no warning (the backend stores it as null).
export const stopHasWarning = (stop) => Boolean(stop?.warning?.trim());

// The "!" badge's orange: the map pin's badge and the icon by the stop's name. #FF9800 was 2.2:1 on white.
export const STOP_WARNING_COLOR = '#EF6C00';
